import React from 'react';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ButtonMinorAction } from '../../../../components/molecules/Btn/ButtonWrapper';
import { Icons } from '../../../../components/atoms/SVG';
import { TooltipPlacement } from '../../../../components/atoms/Tooltip';

export type AttributeGroupFormRemoveButton = {
  removeRule: () => void;
  position: number;
};

export function AttributeGroupFormRemoveButton({ removeRule, position }: AttributeGroupFormRemoveButton) {
  const { t } = useSonTranslation('AttributeGroups');

  return (
    <div className="attribute-group-form__button">
      <ButtonMinorAction
        text={t('form.ruleset.remove', { position })}
        icon={Icons.DELETE_X_SMALL}
        onClick={() => removeRule()}
        tooltipPlacement={TooltipPlacement.TOP}
      />
    </div>
  );
}
